import * as React from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Dropdown, IDropdown, IDropdownOption } from 'office-ui-fabric-react';
import { EnumHelpers } from '@app/Services/EnumHelpers';
import { FunctionOverruleType } from '@app/AppConstants';
import { ViewMode } from './ViewMode';
import { PlanningFunctionOverruleModel } from '@app/Models';

interface IInlineOverruleTypeDropdownCellProps {
    value: string;
    row: PlanningFunctionOverruleModel;
    onChange: (row: PlanningFunctionOverruleModel, field: 'overruleType') => void;
    disabled?: boolean;
}

@observer
export class InlineOverruleTypeDropdownCell extends React.Component<IInlineOverruleTypeDropdownCellProps, {}> {
    store: InlineOverruleTypeDropdownCellStore;

    constructor(props: IInlineOverruleTypeDropdownCellProps) {
        super(props);
        this.store = new InlineOverruleTypeDropdownCellStore(props);
    }

    componentDidUpdate(prevProps: IInlineOverruleTypeDropdownCellProps) {
        if (this.props.row.id !== prevProps.row.id || this.props.row.dateFrom !== prevProps.row.dateFrom || this.props.row.dateTo !== prevProps.row.dateTo) {
            this.store.updateProps(this.props);
        }
    }

    render() {
        if (this.store.mode === ViewMode.view) {
            return (<div onClick={this.store.toEditMode} style={{ minHeight: '16px' }}>{this.store.value}</div>);
        } else {
            return (
                <Dropdown
                    notifyOnReselect={true}
                    options={this.store.functionOverruleTypeOptions}
                    onChange={this.store.onChange}
                    componentRef={this.store.ref}
                    onDismiss={this.store.onMouseLeave}
                    required={true}
                    selectedKey={this.store.functionOverruleType as string}
                />
            );
        }
    }
}

class InlineOverruleTypeDropdownCellStore {
    @observable value: string;
    @observable mode: string = ViewMode.view;
    @observable _initValue: string;
    @observable functionOverruleType: FunctionOverruleType;
    ref: React.RefObject<IDropdown> = React.createRef();
    private _currentProps: IInlineOverruleTypeDropdownCellProps;
    private readonly _entity = 'overruleType';

    constructor(props: IInlineOverruleTypeDropdownCellProps) {
        this.updateProps(props);
    }

    @action
    toEditMode = () => {
        if (this._currentProps.disabled) return;
        this.mode = ViewMode.edit;
        setTimeout(() => {
            this.ref.current && this.ref.current.focus(true);
        }, 0);
    };

    @action
    onMouseLeave = () => {
        this.mode = ViewMode.view;
    };

    @action
    onChange = (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        this.mode = ViewMode.view;
        if (option && this.value !== option.text) {
            this.functionOverruleType = '' + option.key; // option.key is string|number type
            this.value = option.text;
            this._currentProps.row.functionOverruleType = this.functionOverruleType as keyof FunctionOverruleType;
            this._currentProps.onChange(this._currentProps.row, this._entity);
        }
    };

    @computed
    get functionOverruleTypeOptions() {
        return EnumHelpers.toKeyValueArray(FunctionOverruleType);
    }

    @action
    updateProps(props: IInlineOverruleTypeDropdownCellProps) {
        this._initValue = props.value;
        this.value = props.value;
        this._currentProps = { ...props };
        this.functionOverruleType = props.value;
    }
}
